import '@/app/app.css';
import './care.css';

import '@/app/app';
import '@/layouts/main/main';

window.addEventListener('DOMContentLoaded', () => {});

